import { render, staticRenderFns } from "./SettingCompany.vue?vue&type=template&id=29025192&"
import script from "./SettingCompany.vue?vue&type=script&lang=js&"
export * from "./SettingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports